import { Injectable } from '@angular/core';

@Injectable()
export class CacheService {
    private cache: { [key: string]: any };

    constructor() {
        this.cache = {};
    }

    storeResult(key: string, value: any): any {
        this.cache[key] = value;
        return value;
    }

    getResultFromCache(key: string): any {
        return this.cache[key];
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/cache/cache.service.ts